@if (settingsInitialized$ | async) {
    <button [ngClass]="[!isEpcotEnabled ? 'btn' : '', 'add-to-betslip', buttonProperties().state]" [unpatch]="['click']" (click)="onButtonClick()">
        @if (isButtonLocked) {
            <vn-icon name="theme-locked-i" class="lock-icon" [size]="isEpcotEnabled ? '16' : '20'" />
        } @else if (isEpcotEnabled && !defaultButtonOverride) {
            <ng-container *ngTemplateOutlet="returnsText" />
            <div class="total-odds">{{ totalOdds }}</div>
        } @else {
            <div class="btn-text">{{ buttonProperties().text }} {{ totalOdds }}</div>
            <ng-container *ngTemplateOutlet="returnsText" />
        }
    </button>
}
<ng-template #returnsText>
    <div class="returns-text">
        {{ stake | msCurrency: true }} {{ sitecorePopularBetsConfig.messages.StakeReturns }} {{ winnings | msCurrency: true }}
    </div>
</ng-template>
